import { BooleanValueAccessor } from '@ionic/angular';
import { Goal } from 'app/goals/model/model';

export interface Dialog {
  _id: string;
  title: Dictionary<string>;
  description: Dictionary<string>;
  questions: Array<Question>;
  startDate: string;
  endDate: string;
  lastStart: string;
  intervalValue: number;
  intervalUnit: 'day' | 'week' | 'month' | 'year';
  goal?: boolean; // can be used as new goal
  goalId: string; // was issued from a goal
  fullGoal?: Goal; // was issued from a goal, this is the full goal; if set and not set fullGoal.dialog, then use title and description from goal
  ep?: number; // 1 .. Monday, 2 .. Friday 
  thesis?: string; // thesis id if it is a thesis
  contentInfo?: {
    id: string; // _id of content
    uc_id: string; // _id of userContent
    title: Dictionary<string>;
    pos: number;
    length: number;
  }
  sortTime?: string; // used internally for dialog-list
  doneDate?: string; // when dialog (maybe without Questions) has been "OK"ed by user
}

export enum AnswerType {
  Nothing,
  Slider,
  Likert,
  YesNo,
  Text,
  MC,
  DownloadCert
}

export interface Question {
  _id: string;
  dialogId: number;
  text: Dictionary<string>;
  answerType: AnswerType;
  minLabel?: Dictionary<string>;
  maxLabel?: Dictionary<string>;
  response?: string;
}

export interface Answer {
  questionId: string;
  answer: string;
  dialogId?: string; // for dialogs without answer
}

export interface DialogGroups {
  [date: string]: Array<Dialog>;
}

export interface ThesesStats {
  index: number;
  date: Date;
  name: string;
  val: number;
  range: string; // w,m,q
  group: string ; // u,c
}

export interface DialogStats {
  cntDiaUser: number;
  cntDiaGroup: number;
  cntContUser: number,
  cntContGroup: number;
  level: number;
  cntGroup: number;
}